import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import { Box, Heading } from "@chakra-ui/react"

export const Header = ({ siteTitle }) => {
  return (
    <header>
      <Box px="8" py="4">
        <Heading as="p" fontSize="lg">
          <Link to="/">{siteTitle}</Link>
        </Heading>
      </Box>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}
